import React from 'react';
import { IconProps } from '../IconProps';
const SvgTarget = ({
  primaryColor,
  secondaryColor,
  tertiaryColor,
  ...props
}: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
    <g
      clipPath="url(#Target_svg__clip0_10097_8969)"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={primaryColor}
    >
      <path d="M13.078.678a.667.667 0 00-1.104-.26L9.75 2.64a.667.667 0 00-.16.682l.536 1.609-2.598 2.598a.667.667 0 00.943.942l2.598-2.597 1.609.536c.24.08.503.018.682-.16l2.222-2.223a.667.667 0 00-.26-1.104l-1.684-.561-.561-1.684z" />
      <path d="M8.449 4.19a.667.667 0 01-.628.704 3.112 3.112 0 103.284 3.285.667.667 0 111.332.075 4.445 4.445 0 11-4.691-4.691c.367-.021.682.26.703.628z" />
      <path d="M.889 8A7.111 7.111 0 018.062.89a.667.667 0 01-.012 1.333H8A5.778 5.778 0 1013.778 8v-.05a.667.667 0 111.333-.013V8A7.111 7.111 0 01.889 8z" />
    </g>
    <defs>
      <clipPath id="Target_svg__clip0_10097_8969">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTarget;
